@let rightsOfferingData = rightsOffering();

<div class="row">
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">OVERVIEW</h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
                @if (rightsOfferingData.ro_status.length > 1) {
                <tr>
                    <td>Status</td>
                    <td class="ps-2">
                        @if (rightsOfferingData.ro_withdrawn != '') {
                            Withdrawn
                        } @else  {
                            {{rightsOfferingData.ro_status}}
                        }
                    </td>
                </tr>
                }
                @if (rightsOfferingData.ro_size.length > 1) {
                <tr>
                    <td>Size</td>
                    <td class="ps-2">{{ rightsOfferingData.ro_size }}</td>
                </tr>
                }

                @if (rightsOfferingData.ro_financing_type.length > 1) {
                <tr>
                    <td>Financing Type</td>
                    <td class="ps-2">{{ rightsOfferingData.ro_financing_type }}</td>
                </tr>
                }
                @if (rightsOfferingData.ro_securities_offering_type.length > 1) {
                <tr>
                    <td>Securities Offering Type</td>
                    <td class="ps-2">{{ rightsOfferingData.ro_securities_offering_type }}</td>
                </tr>
                }
                @if (rightsOfferingData.current.ro_discount_to_plan_equity_value.length > 1) {
                <tr>
                    <td>Discount To Plan Equity Value</td>
                    <td class="ps-2">{{ rightsOfferingData.current.ro_discount_to_plan_equity_value}} %</td>
                </tr>
                }
                @if (rightsOfferingData.current.ro_participants.length > 0) {
                <tr>
                    <td>Rights Offering Participants</td>
                    <td class="ps-2">{{ rightsOfferingData.current.ro_participants.join(', ')}}</td>
                </tr>
                }
                @if (rightsOfferingData.current.ro_use_of_proceeds.length > 0) {
                <tr>
                    <td>Uses of Proceeds</td>
                    <td class="ps-2">{{ rightsOfferingData.current.ro_use_of_proceeds.join(', ')}}</td>
                </tr>
                }
                @if (rightsOfferingData.ro_withdrawn.length > 1) {
                <tr>
                    <td>Withdrawn?</td>
                    <td class="ps-2">{{ rightsOfferingData.ro_withdrawn}}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    @if (rightsOfferingData.current.ro_details.length > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">DETAILS</h2>

        @let detailsColumns = getPopulatedColumns(rightsOfferingData.current.ro_details, {currency: true});
        <table cdk-table [dataSource]="rightsOfferingData.current.ro_details" class="table table-borderless definitions w-100 table-striped" >
            <ng-container cdkColumnDef="ro_invested_amount">
                <th cdk-header-cell *cdkHeaderCellDef>Invested Amount</th>
                <td cdk-cell *cdkCellDef="let detail">
                    {{ detail.ro_invested_amount | currency: detail.currency}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="ro_new_security_percentage">
                <th cdk-header-cell *cdkHeaderCellDef>% of New Security</th>
                <td cdk-cell *cdkCellDef="let detail">
                    @if (detail.ro_new_security_percentage > 0) {
                        {{ detail.ro_new_security_percentage }} %
                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="linked_instruments">
                <th cdk-header-cell *cdkHeaderCellDef>Post Petition Instrument</th>
                <td cdk-cell *cdkCellDef="let detail">
                    <ng-container *ngTemplateOutlet="instrumentList; context: {$implicit:detail.linked_instruments}"></ng-container>
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="detailsColumns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: detailsColumns"></tr>
        </table>
    </div>
    }
    @if (rightsOfferingData.current.ro_qualified_participant_plan_classes.length > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">QUALIFIED PARTICIPANT PLAN CLASSES</h2>
        <table class="table w-100">
            <thead>
                <tr>
                    <th>Plan Class Name</th>
                    <th>Claims Type</th>
                    <th>DIP &amp; Pre Petition Instrument</th>
                </tr>
            </thead>
            <tbody>
                @for (planClass of rightsOfferingData.current.ro_qualified_participant_plan_classes; track planClass) {
                <tr>
                    <td>{{ planClass.plan_class_name }}</td>
                    <td>
                        @if (planClass.claims_type.length > 0) {
                        {{ planClass.claims_type.join(', ') }}
                        }
                    <td>
                        <ng-container *ngTemplateOutlet="instrumentList; context: {$implicit:planClass.linked_instruments}"></ng-container>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
    @if (rightsOfferingData.current.ro_backstop_parties.length > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">BACKSTOP PARTIES</h2>
        @let backstopPartiesColumns = getPopulatedColumns(rightsOfferingData.current.ro_backstop_parties, {company_name: true, group_id: true});
        <table cdk-table [dataSource]="rightsOfferingData.current.ro_backstop_parties" class="table table-borderless definitions w-100 table-striped" >
            <ng-container cdkColumnDef="group_name">
                <th cdk-header-cell *cdkHeaderCellDef>Backstop Ad Hoc Group</th>
                <td cdk-cell *cdkCellDef="let backStopParty">
                    {{ backStopParty.group_name }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="company_id">
                <th cdk-header-cell *cdkHeaderCellDef>Backstop Party</th>
                <td cdk-cell *cdkCellDef="let backStopParty">
                    @if (backStopParty.company_id > 0) {
                    <a href="/organizations/{{backStopParty.company_id}}" target="_blank">{{ backStopParty.company_name }}</a>
                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="backstop_amount">
                <th cdk-header-cell *cdkHeaderCellDef class="text-end">Backstop Amount ($)</th>
                <td cdk-cell *cdkCellDef="let backStopParty" class="text-end">
                    {{ backStopParty.backstop_amount | currency: 'USD' }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="total_size_percentage">
                <th cdk-header-cell *cdkHeaderCellDef class="text-end">% of Total Size</th>
                <td cdk-cell *cdkCellDef="let backStopParty" class="text-end">
                    {{ backStopParty.total_size_percentage | number: '1.0-2' }}%
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="backstopPartiesColumns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: backstopPartiesColumns"></tr>
        </table>
    </div>
    }

    @if (rightsOfferingData.current.ro_fees.length > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">FEES</h2>
        @let feesColumns = getPopulatedColumns(rightsOfferingData.current.ro_fees, {fee_amount_percent: true, fee_amount_dollar: true, fee_amount: true, fee_other: true});
        <table cdk-table [dataSource]="rightsOfferingData.current.ro_fees" class="table table-borderless definitions w-100 table-striped" >
            <ng-container cdkColumnDef="fee_type">
                <th cdk-header-cell *cdkHeaderCellDef>Type</th>
                <td cdk-cell *cdkCellDef="let feeLine">
                    @if (feeLine.fee_type == 'Other') {
                    {{ feeLine.fee_other }}
                    } @else {
                    {{ feeLine.fee_type }}
                    }
                </td>
            </ng-container>
            <ng-container cdkColumnDef="amount_type">
                <th cdk-header-cell *cdkHeaderCellDef class="text-end pe-2">Amount</th>
                <td cdk-cell *cdkCellDef="let feeLine" class="text-end pe-2">
                    @if (feeLine.amount_type === '%') {
                        @if (feeLine.fee_amount_percent > 0) {
                        {{ feeLine.fee_amount_percent | number: '1.0-2' }} %
                        }
                    } @else if (feeLine.amount_type === 'USD') {
                        @if (feeLine.fee_amount_dollar > 0) {
                        {{ feeLine.fee_amount_dollar | currency: 'USD' }}
                        }
                    } @else {
                    {{ feeLine.amount_type }}
                    }
                </td>
            </ng-container>
            <ng-component cdkColumnDef="linked_instruments">
                <th cdk-header-cell *cdkHeaderCellDef>Post-petition Instruments</th>
                <td cdk-cell *cdkCellDef="let feeLine">
                    <ng-container *ngTemplateOutlet="instrumentList; context: {$implicit:feeLine.linked_instruments}"></ng-container>
                </td>
            </ng-component>
            <ng-container cdkColumnDef="payment_form">
                <th cdk-header-cell *cdkHeaderCellDef>Payment Form</th>
                <td cdk-cell *cdkCellDef="let feeLine">
                    {{ feeLine.payment_form }}
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="feesColumns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: feesColumns"></tr>
        </table>
    </div>
    }
    @if (rightsOfferingData.current.ro_plan_values.length > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">PLAN VALUES</h2>

        @let planValueColumns = getPopulatedColumns(rightsOfferingData.current.ro_plan_values);
        <table cdk-table [dataSource]="rightsOfferingData.current.ro_plan_values" class="table table-borderless definitions w-100 table-striped" >
            <ng-container cdkColumnDef="plan_value">
                <th cdk-header-cell *cdkHeaderCellDef>Plan Value</th>
                <td cdk-cell *cdkCellDef="let planValue">
                    {{ planValue.plan_value }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="exact">
                <th cdk-header-cell *cdkHeaderCellDef class="text-end">Amount</th>
                <td cdk-cell *cdkCellDef="let planValue" class="text-end">
                    {{ planValue.exact | currency: 'USD' }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="min">
                <th cdk-header-cell *cdkHeaderCellDef class="text-end">Min</th>
                <td cdk-cell *cdkCellDef="let planValue" class="text-end">
                    {{ planValue.min | currency: 'USD' }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="max">
                <th cdk-header-cell *cdkHeaderCellDef class="text-end">Max</th>
                <td cdk-cell *cdkCellDef="let planValue" class="text-end">
                    {{ planValue.max | currency: 'USD' }}
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="planValueColumns"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: planValueColumns"></tr>
        </table>
    </div>
    }
    @if (rightsOfferingData.court_documents.length > 0) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">SOURCE DOCUMENTS</h2>
        <court-documents [documents]="rightsOfferingData.court_documents" colsDefn="" [showHeader]="false"></court-documents>
    </div>
    }

</div>

<ng-template #instrumentList let-instruments>
    <ul class="list-unstyled m-0">
        @for (instrument of instruments; track instrument.articleID) {
        <li>
            <a class="a_without_href" (click)="openInstrument($event, situationID(), instrument.iid)">{{ instrument.instrument_name }}</a>
        </li>
        }
    </ul>
</ng-template>